import { createAction, props } from '@ngrx/store';
import {LocationSet} from '@emm/core/models/location-set.model';
import {Venue} from '@emm/core/models/venue.model';

export enum MenuLocationSetsActions {
    LoadAllByScope = '[Menu Location Sets Effects] Load All Location Sets By Scope',
    LoadAllByScopeSuccess = '[Menu API] Load All Location Sets By Scope Success',
    LoadAllByScopeFailure = '[Menu API] Load All Location Sets By Scope Failure',
    LoadLocationsByParent = '[Menu Filters] Load Locations By Location Set Type',
    LoadLocationsByParentSuccess = '[Menu Filters] Load Locations By Location Set Type Success',
    LoadLocationsByParentFailure = '[Menu Filters] Load Locations By Location Set Type Failure',
    Select = '[Menu Filters] Select Location Set',
    SelectVenue = '[Menu Filters] Select Venue',
    UpdateFilter = '[Location Set Picker] Update Filter',
}

export const LocationSetsActions = {
    loadAllByScope: createAction(MenuLocationSetsActions.LoadAllByScope),
    loadAllByScopeSuccess: createAction(MenuLocationSetsActions.LoadAllByScopeSuccess, props<{ locationSets: LocationSet[] }>()),
    loadAllByScopeFailure: createAction(MenuLocationSetsActions.LoadAllByScopeFailure, props<{ error: any }>()),
    loadLocationsByParent: createAction(
        MenuLocationSetsActions.LoadLocationsByParent,
        props<{ parentTag: string }>()
    ),
    loadLocationsByParentSuccess: createAction(
        MenuLocationSetsActions.LoadLocationsByParentSuccess,
        props<{ locationSets: LocationSet[] }>()
    ),

    loadLocationsByParentFailure: createAction(
        MenuLocationSetsActions.LoadLocationsByParentFailure,
        props<{ error: any }>()
    ),
    select: createAction(MenuLocationSetsActions.Select, props<{ tag: string }>()),
    selectVenue: createAction(MenuLocationSetsActions.SelectVenue, props<{ venue: Venue }>()),
    updateFilter: createAction(MenuLocationSetsActions.UpdateFilter, props<{ filter: string }>())
};

export const AsyncActions = {
    loadActions: [LocationSetsActions.loadAllByScope, LocationSetsActions.loadLocationsByParent],
    successActions: [LocationSetsActions.loadAllByScopeSuccess, LocationSetsActions.loadLocationsByParentSuccess],
    errorActions: [LocationSetsActions.loadAllByScopeFailure, LocationSetsActions.loadLocationsByParentFailure]
};
